import { isEmailEnabled } from './isEnabled'

export default isEmailEnabled
